import { DataConsumerIntegrationsTable } from "../../components/integration-platform/data-consumer/DataConsumerIntegrationsTable";
import { useActiveUserRoles } from "../../util/useActiveUserRoles";
import { DataConsumerIntegrationRedirect } from "./DataConsumerIntegrationsRedirect";

export function DataConsumerIntegrations() {
  const { isSolutionOperator } = useActiveUserRoles();

  if (isSolutionOperator) return <DataConsumerIntegrationsTable />;
  else return <DataConsumerIntegrationRedirect />;
}
